import { Checkbox } from "@chakra-ui/react";
import React from "react";

type SelectAllCheckboxProps = {
  unSelectAll: (...props: any) => void;
  selectAll: (...props: any) => void;
  size?: any;
};

const SelectAllCheckbox = (props: SelectAllCheckboxProps) => {
  const { unSelectAll, selectAll, size = "lg" } = props;
  return (
    <Checkbox
      type="checkbox"
      colorScheme="whatsapp"
      size={size}
      onChange={(e) => {
        if (e.target.checked) {
          selectAll();
        } else {
          unSelectAll();
        }
      }}
    />
  );
};

export default SelectAllCheckbox;
